export enum TransactionTypeEnum {
  InvoiceLineItem = 'Invoice Line Item',
  Payments = 'Invoice Payment',
  Adjustments = 'Adjustment',
  UnappliedPayments = 'Unapplied Payment',
}
